import tippy from 'tippy.js'

const TooltipDirective = {
  mounted(el, binding) {
    let content = ''
    let placement = 'top'

    if(typeof binding.value === 'string') {
      content = binding.value
    }
    else {
      content = binding.value.content
      placement = binding.value.placement
    }

    el.tooltip = tippy(el, {
      content,
      placement,
      theme: 'tooltip',
      duration: 100,
      allowHTML: true,
      zIndex: 11001,
    })
  },

  updated(el, binding) {
    let content = ''

    if(typeof binding.value === 'string') {
      content = binding.value
    }
    else {
      content = binding.value.content
    }
    if(el.tooltip) el.tooltip.setContent(content)
  },
  
  unmounted(el) {
    if(el.tooltip) el.tooltip.destroy()
  },
}

export default TooltipDirective